import { ReactNode } from 'react';

export const en = {
  mergeSuccessTitle: 'Tasks merged successfully',
  mergeSuccessDescription: (total: number) =>
    `${total} task${total > 1 ? 's' : ''} have been merged into task `,
  viewMergedTask: 'View merged task'
};

export type Translations = typeof en;
